import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

export interface BreadcrumbItem {
	label: string
	path?: string
}

interface BreadcrumbsProps {
	items: BreadcrumbItem[]
}

const BreadcrumbsContainer = styled.nav`
	display: flex;
	align-items: center;
	padding: 1rem 0;
	font-size: 0.875rem;
	color: #6b7280;
	background: transparent;

	@media (max-width: 600px) {
		padding: 0.625rem 0;
		font-size: 0.8125rem;
	}
`

const BreadcrumbList = styled.ol`
	display: flex;
	align-items: center;
	list-style: none;
	margin: 0;
	padding: 0;
	gap: 0.5rem;
	flex-wrap: wrap;

	@media (max-width: 600px) {
		gap: 0.375rem;
	}
`

const BreadcrumbItem = styled.li`
	display: flex;
	align-items: center;
	gap: 0.5rem;

	@media (max-width: 600px) {
		gap: 0.375rem;
	}
`

const BreadcrumbLink = styled(Link)`
	color: #6b7280;
	text-decoration: none;
	transition: color 0.2s;

	&:hover {
		color: #f97316;
	}
`

const BreadcrumbCurrent = styled.span`
	color: #111827;
	font-weight: 500;
`

const BreadcrumbSeparator = styled.span`
	color: #d1d5db;
	user-select: none;
`

const ChevronRight = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
		<path
			fillRule="evenodd"
			d="M6.22 3.22a.75.75 0 011.06 0l4.25 4.25a.75.75 0 010 1.06l-4.25 4.25a.75.75 0 01-1.06-1.06L9.94 8 6.22 4.28a.75.75 0 010-1.06z"
		/>
	</svg>
)

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
	if (items.length === 0) return null

	return (
		<BreadcrumbsContainer aria-label="Breadcrumb">
			<BreadcrumbList>
				{items.map((item, index) => {
					const isLast = index === items.length - 1

					return (
						<BreadcrumbItem key={index}>
							{!isLast && item.path ? (
								<>
									<BreadcrumbLink to={item.path}>{item.label}</BreadcrumbLink>
									<BreadcrumbSeparator>
										<ChevronRight />
									</BreadcrumbSeparator>
								</>
							) : (
								<BreadcrumbCurrent aria-current="page">{item.label}</BreadcrumbCurrent>
							)}
						</BreadcrumbItem>
					)
				})}
			</BreadcrumbList>
		</BreadcrumbsContainer>
	)
}

export default Breadcrumbs

